import React from 'react';
import { Link } from 'react-router-dom';
import ContentTitle from '../../components/content/ContentTitle';
import ProfileIdentity from '../../components/content/ProfileIdentity';
import { albumPath } from '../../components/content/albumPath';
import { useWebLocale } from '../../contexts/WebLocaleContext';

export default function DividedOpinionCard({ detail, pair }) {
  const { t } = useWebLocale();
  const path = albumPath(detail);
  const genre =
    typeof detail.genres?.[0] === 'string' ? detail.genres[0] : detail.genres?.[0]?.name;
  const metadata = [detail.releaseDate?.slice(0, 4), genre].filter(Boolean).join(' · ');
  return (
    <div className="pp-divided-card">
      <Link className="pp-divided-album" to={path}>
        <img src={detail.imageUrl || undefined} alt="" loading="lazy" />
        <div className="pp-divided-album-copy">
          <ContentTitle
            style={{
              fontSize: 'var(--pp-card-title-size)',
              lineHeight: 'var(--pp-card-title-line)',
            }}
            title={detail.title}
            explicit={detail.contentRating === 'EXPLICIT'}
          />
          <span>{detail.artist?.name}</span>
          {metadata && <span className="pp-secondary">{metadata}</span>}
        </div>
        <div className="pp-divided-score">
          <strong>
            {detail.averageRating != null && Number.isFinite(Number(detail.averageRating))
              ? Number(detail.averageRating).toFixed(1)
              : '—'}
          </strong>
          {detail.reviewCount != null && (
            <span className="pp-secondary">
              {t('home.reviewCount', { count: detail.reviewCount })}
            </span>
          )}
        </div>
      </Link>
      <div className="pp-opinions">
        {[pair.high, pair.low].map((review, index) => (
          <Link
            className={`pp-opinion ${index === 0 ? 'pp-opinion-positive' : 'pp-opinion-critical'}`}
            key={review.id}
            to={`${path}/user-reviews/${review.id}`}
          >
            <div className="pp-opinion-byline">
              <ProfileIdentity
                name={review.user?.nickname}
                image={review.user?.profileImageUrl}
                mark={review.user?.profileMark}
              />
              <span className="pp-opinion-score">
                <span aria-hidden="true">★</span> {Number(review.rating).toFixed(1)}
              </span>
            </div>
            <p>{review.content.trimStart()}</p>
            <span className="pp-opinion-engagement pp-secondary">
              {t('home.engagement', {
                likes: review.likeCount ?? 0,
                comments: Array.isArray(review.comments) ? review.comments.length : 0,
              })}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
